module.exports = __webpack_public_path__ + "static/media/RLC_8269a.a339fc26.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/kukenan/RLC_8269a.JPG
// module id = 31
// module chunks = 0